/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {OfferDetailView} from "../../offer/views/OfferDetailView";
const route = [{webpackEntry: "offerDetail", path: rpAppPath.offer.detail.base, component: OfferDetailView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {OfferDetailView} from "../../offer/views/OfferDetailView";
const route = [{webpackEntry: "offerDetail", path: rpAppPath.offer.detail.base, component: OfferDetailView}];

(function () {
    rpClient(route);
})();
